module.exports = __webpack_public_path__ + "static/media/kids.e145ee0a.jpg";